<template>
  <div id="app">
    <vue-title :title="`${(this.$route.name || 'Loading').replace('.',' ').replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))} - Crusade Cloud`"></vue-title>
    <navigation></navigation>
      <b-notification v-for="(error,index) in (this.errors || [] ).filter((item) => {return item.global})" :key="'errer'+index"
          type="is-danger"
          aria-close-label="Close notification"
          role="alert">
        {{error.global}}
      </b-notification>
    <router-view />    
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import { mapGetters } from "vuex";
export default {
  computed:{ ...mapGetters(['errors'])},
  components: {
    Navigation,
  }
};
</script>

<style lang="scss">

  // Import Bulma's core
  @import "~bulma/sass/utilities/_all";

  // Set your colors
  $primary: #ff5757;
  $primary-light: #ff8585;
  $primary-dark: #bb3131;
  $primary-invert: findColorInvert($primary);
  $twitter: #4099FF;
  $twitter-invert: findColorInvert($twitter);

  // Setup $colors to use as bulma classes (e.g. 'is-twitter')
  $colors: (
      "white": ($white, $black),
      "black": ($black, $white),
      "light": ($light, $light-invert),
      "dark": ($dark, $dark-invert),
      "primary": ($primary, $primary-invert, $primary-light, $primary-dark),
      "info": ($info, $info-invert),
      "success": ($success, $success-invert),
      "warning": ($warning, $warning-invert),
      "danger": ($danger, $danger-invert),
      "twitter": ($twitter, $twitter-invert)
  );

  // Links
  $link: $primary;
  $link-invert: $primary-invert;
  $link-focus-border: $primary;

  // Notifications
  $notification-radius: 0;

  // Other
  // $body-background-color: rgb(5, 5, 9);
  
  // $text: $light;
  // $text-strong: $light;
  // $label-color: $text;
  // $title-color: $text;

  // $scheme-main: rgb(5, 5, 9);
  // $scheme-invert: $light;

  // Import Bulma and Buefy styles
  @import "~bulma";

  .extras a { margin-right: map-get($spacing-values,"3")}
  table.table td { vertical-align: middle; }

  @import "~buefy/src/scss/buefy";

</style>